// coefficient = 2.72 - one percent of LoadingProgressStyled width
export const COEFFICIENT = 2.72;
export const VIEW_360_STEP = 13;
export const VIEW_360_WRAPPER_TEST_ID = 'view_360_wrapper';
export const LOADING_MODEL_TEST_ID = 'loading_model_test_id';
export const IMAGES_LIST_ITEM = 'View360ImagesList_list_item';
